<template>
  <a-modal :getContainer="getContainer" v-model:visible="visible" :title="title" @cancel="close" :keyboard="false"
           :maskClosable="false" :footer="null" :afterClose="afterClose">
    <a-form ref="form" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="文件">
        <a-upload
            :action="action"
            :headers="uploadHeaders"
            :file-list="fileList"
            :before-upload="beforeUpload"
            @change="handleFileChange"
        >
          <a-button>
            <template #icon>
              <UploadOutlined/>
            </template>
            点击上传
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
    <div class="form-bootom-button">
      <a-button type="button" @click="close">关闭</a-button>
    </div>
  </a-modal>
</template>

<script>
import api from "@/api";
import CommonMixin from "@/mixin/CommonMixin";

export default {
  name: 'ImportModal',
  mixins: [CommonMixin],
  data() {
    return {
      visible: false,
      title: '导入',
      form: {},
      // 上传文件
      action: window._CONFIG["apiBaseUrl"] + api.auxiliaryAfterPositiveImportData,
      fileList: [],
    }
  },
  methods: {
    getContainer() {
      return document.getElementById("comptainer_auxiliary_after_positive");
    },
    close() {
      this.visible = false;
    },
    afterClose() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
    show() {
      this.visible = true;
    },
    handleFileChange(info) {
      if (info.file.status === "done") {
        this.$message.success("数据处理中，请稍后查看！");
        this.close();
      } else if (info.file.status === "error") {
        let message = "导入失败！";
        if (info.file.response && info.file.response.message) {
          message = info.file.response.message;
        }
        this.$message.error(message);
      }
      this.fileList = info.fileList;
    },
  }
}
</script>
